import { Trans } from "react-i18next";
import { commonConstant } from "../../../server/triage/constants";
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { getAppInsights } from "../../../App/TelemetryService";



export function setTriageRequest({ state, setState, props }) {

  console.log('setTriageRequest', props)

  return setState({
    triageRequest: { ...state.triageRequest, ...props }
  })
}

export function setTriageResponse({ state, setState, props }) {

  console.log('setTriageResponse', props)

  return setState({
    triageResponse: { ...state.triageResponse, ...props }
  })
}

export async function sendTriageRequest({ props = {}, state, actions, setState, getState }) {

  const { action = '', data = {} } = props

  console.log(`Triage request "${action}"`, props)

  if (!action) return


  // Remove any previous error for this action
  const { errors } = state.triageResponse

  if (errors[action]) {
    delete errors[action]
    actions.setTriageResponse({ errors })
  }

  try {

    const { response, error } = await actions.api({
      type: 'triage',
      action,
      data
    })

    if (error) throw error
    if (!response) throw new Error('Empty response')

    console.log(`Triage response "${action}"`, response)

    actions.setTriageResponse(response)

    return response

  } catch (error) {
    console.log(`Triage error "${action}"`, error.message || error)
    getAppInsights().trackException({
      error: new Error(error),
      severityLevel: SeverityLevel.Error
    })
    actions.setTriageResponse({
      errors: {
        ...getState().triageResponse.errors,
        [action]: error
      }
    })

    var pageFlow = commonConstant.APIError;
    var errorMessage = <Trans i18nKey="SomethingWentWrong"></Trans>;
    if (state.azure.accessToken == null && !state.IsValidUser) {
      pageFlow = commonConstant.PreLogin;
      errorMessage = <Trans i18nKey="SomethingWentWrongPreLogin"></Trans>;
    }

    actions.setErrorModal({
      title: <Trans i18nKey="findcareoption.Careoptions.Please_confirm"></Trans>,
      message: errorMessage,
      comingFrom: pageFlow,
      setState
    })

    return false
  }
}
